<template>
  <b-modal ref="modalRef" centered title="Disable award" @hidden="onHidden">
    <p>
      Are you sure you want to disable <strong>{{ programName }}</strong
      >?
    </p>
    <p class="text-muted mb-0">
      When disabled, this award will not be visible to employees and no new nominations can be made.
    </p>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="modalRef?.hide()">Cancel</b-button>
      <b-button variant="danger" @click="onConfirm">Disable award</b-button>
    </template>
  </b-modal>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  programName: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['confirmed']);

const modalRef = ref(null);

const show = () => {
  modalRef.value?.show();
};

const onConfirm = () => {
  emit('confirmed');
  modalRef.value?.hide();
};

const onHidden = () => {
  // No cleanup needed
};

defineExpose({ show });
</script>
